import type { TFunction } from 'i18next'

interface PlaceholdersForT {
  hostname: string
  ipAddress: string
}

export function placeholdersFor(t: TFunction<'cases'>): PlaceholdersForT {
  return {
    hostname: t('infrastructure.placeholders.hostname'),
    ipAddress: t('infrastructure.placeholders.ipAddress'),
  }
}
